import { ILocalizationClient } from "@multiweb/clients/localization";
import { LocalizationClient } from "./LocalizationClient";

export function defaultFactory(webServiceUrl: string): ILocalizationClient {
    return new LocalizationClient(webServiceUrl);
}
